import ScalarIconPlugsConnected_vue_vue_type_script_setup_true_lang_default from "./ScalarIconPlugsConnected.vue.script.js";
//#region src/components/ScalarIconPlugsConnected.vue
var ScalarIconPlugsConnected_default = ScalarIconPlugsConnected_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconPlugsConnected_default as default };

//# sourceMappingURL=ScalarIconPlugsConnected.js.map